import React from 'react';

import './SkipLink.scss';

interface SkipLinkProps {
    skipTo: string;
    linkText: string;
}

const SkipLink: React.FC<SkipLinkProps> = ({ skipTo, linkText }) => {
    return (
        <a className="skip-link" href={skipTo}>
            {linkText}
        </a>
    );
};

export default SkipLink;
